import  { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Lore from 'components/Lore';

const LoreBrowser = () => {

    const params = useParams();
    useEffect(() => {
        console.log('params', params);
    }, [params]);
    const slug = params['*'];

    return slug ?
        <Stack m={1}><Lore slug={slug} /></Stack> :
        <div>pick a slug first</div>;
};


export default LoreBrowser;
